import { render } from "./OnlineTutoringView.vue?vue&type=template&id=4b48c2f4&scoped=true"
import script from "./OnlineTutoringView.vue?vue&type=script&lang=js"
export * from "./OnlineTutoringView.vue?vue&type=script&lang=js"

import "./OnlineTutoringView.vue?vue&type=style&index=0&id=4b48c2f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b48c2f4"]])

export default __exports__